import { OldBlankDoTestPlugin, OldBlankDoTestPluginProps, OldBlankPlugin } from '../BlankEditor/Creator/OldBlankPlugin';
import { OldBlankResultPlugin } from '../BlankEditor/Result/OldBlankResultPlugin';
import { withBlank } from '../BlankEditor/withBlank';
import { EditableVoidPlugin } from '../DolEditor/elements/editable-blank-voids/EditableVoidBlankPlugin';
import { useSideToolbarPlugins } from '../DolEditor/toolbars/sidebar/defaults';

export const useBlankEditorCreator = ({ blanks, onRemoveBlank }) => {
  return useSideToolbarPlugins({
    extraPlugins: [OldBlankPlugin({ blanks, onRemoveBlank })],
    extraEditorChains: [withBlank],
  });
};

export const useBlankEditorResult = ({
  blanks,
  currentSelectedIndex,
  showQuestionNo,
  testMode,
}) => {
  return useSideToolbarPlugins({
    extraPlugins: [
      OldBlankResultPlugin({ blanks, currentSelectedIndex, showQuestionNo, testMode }),
    ],
    extraEditorChains: [withBlank],
  });
};

export const useBlankEditorDoTest = (blankOptions: OldBlankDoTestPluginProps) => {
  return useSideToolbarPlugins({
    extraPlugins: [OldBlankDoTestPlugin(blankOptions)],
  });
};

export const useBlankEditorDiagramLabel = ({
  blanks,
  questionNo,
  readOnly,
  mode,
  userAnswers,
  selectBlankIndex,
  onUserAnswerChange,
  onClickBlank,
}) => {
  const { plugins, editorChains } = useSideToolbarPlugins({
    extraPlugins: [
      EditableVoidPlugin({
        blanks,
        questionNo,
        readOnly,
        mode,
        userAnswers,
        selectBlankIndex,
        onUserAnswerChange,
        onClickBlank,
      }),
    ],
  });

  return {
    plugins,
    editorChains,
  };
};
